import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { GamesService } from '@core/services/games.service';
import { RouterLink } from '@angular/router';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
  selector: 'app-home-games',
  imports: [SvgIconComponent, RouterLink],
  templateUrl: './home-games.component.html',
  styleUrl: './home-games.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    class: 'w-full h-full flex flex-col gap-16',
  },
})
export class HomeGamesComponent {
  public readonly gameService = inject(GamesService);

  public games = computed(() =>
    this.gameService.gamesList().map((g) => {
      return {
        ...g,
        isNew: ['Case Battles', 'Cases'].includes(g.name),
      };
    })
  );
}
